import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import type { PublicInterestList, PublicInterestRecord, PublicInterestStatus } from '../types';

const PAGE_SIZE = 50;

export async function listPublicInterest(cursor?: string): Promise<PublicInterestList> {
  const call = httpsCallable<{ limit: number; cursor?: string }, PublicInterestList>(functions, 'listPublicInterest');
  const result = await call({ limit: PAGE_SIZE, ...(cursor ? { cursor } : {}) });
  return result.data;
}

export async function updatePublicInterestStatus(
  interestId: string,
  status: PublicInterestStatus,
): Promise<PublicInterestRecord> {
  const call = httpsCallable<{ interestId: string; status: PublicInterestStatus }, PublicInterestRecord>(functions, 'updatePublicInterestStatus');
  const result = await call({ interestId, status });
  return result.data;
}

export function formatInterestDate(value: string | null): string {
  if (!value) return 'Not recorded';
  const date = new Date(value);
  if (Number.isNaN(date.valueOf())) return 'Not recorded';
  return date.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}

export function interestErrorMessage(error: unknown, operation: 'list' | 'update'): string {
  const rawCode = typeof error === 'object' && error && 'code' in error ? String(error.code) : '';
  const code = rawCode.replace(/^functions\//, '');
  if (code === 'unauthenticated') return 'Your session has expired. Sign in again to manage Interest.';
  if (code === 'permission-denied') return 'You do not have permission to manage Interest.';
  if (operation === 'update' && code === 'not-found') return 'This Interest record is no longer available.';
  return operation === 'list'
    ? 'Interest records could not be loaded. Please try again.'
    : 'The Interest status could not be updated. Please try again.';
}
